<template>
    <div>
        <h1>商品列表</h1>
    </div>
</template>
<script>
export default {
    name: "ProductListIndex",
    props: {
        datas: Object,
    },
    data() {
        return {
            rightcom: "ProductListIndex",
        }
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
    h1 {
        color: #333;
    }
</style>
